const config = {
  dataUrl: '/node/home/api/recent-activity/fullV1',
  options: {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }
};

const DEFAULT_RECENT_ACTIVITY = {
  data: [],
  title: ''
};

const getRecentActivity = () =>
  fetch(config.dataUrl, config.options)
    .then(response => response.json())
    .catch(() => DEFAULT_RECENT_ACTIVITY);

export { getRecentActivity };
